import { useState } from 'react';
import { getWorkshopPublicationFigures } from '../utils/publicationAnalysis';
import PublicationAnalysisMethodNote from './PublicationAnalysisMethodNote';
import './CompareWorkshops.css';
import './PublicationAnalysisFigure.css';

const CompareWorkshopsPublicationAnalysisRow = ({ title, titleBadge, diagramKey, comparedWorkshops }) => {
  const [isModalActive, setIsModalActive] = useState(false);
  const [isRowLayout, setIsRowLayout] = useState(true);
  const switchId = `layoutSwitch-${diagramKey}`;

  const figuresByWorkshop = comparedWorkshops.map(workshop => ({
    workshop,
    figures: getWorkshopPublicationFigures(workshop, diagramKey)
  }));

  const comparisonFigures = figuresByWorkshop.flatMap(({ workshop, figures }) =>
    figures.map(figure => ({
      ...figure,
      key: `${workshop.id}-${figure.landUse}`,
      workshopName: workshop.name
    }))
  );

  if (comparisonFigures.length === 0) {
    return null;
  }

  return (
    <div className="columns">
      <div className="column is-2 mt-3 mb-3">
        <div className="title is-5">
          {title}
        </div>
        {titleBadge && <span className="tag is-light">{titleBadge}</span>}
      </div>
      {figuresByWorkshop.map(({ workshop, figures }) => (
        <div key={workshop.id} className="column">
          {figures.length === 0 && (
            <div className="publication-analysis-card publication-analysis-card-missing">
              <div className="content">
                <p className="has-text-grey">Analysis diagram is not available.</p>
              </div>
            </div>
          )}
          {figures.map(figure => (
            <button
              key={figure.landUse}
              type="button"
              className="comparison-publication-analysis-thumb"
              onClick={() => setIsModalActive(true)}
            >
              {figures.length > 1 && (
                <span className="tag is-light mb-2">{figure.landUse}</span>
              )}
              <img src={figure.src} alt={figure.alt} />
            </button>
          ))}
        </div>
      ))}

      <div className={`modal ${isModalActive ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={() => setIsModalActive(false)}></div>
        <button className="modal-close is-large modal-close-margin" aria-label="close" onClick={() => setIsModalActive(false)}></button>
        <div className="modal-content comparison-modal-content">
          <div className="block p-6">
            <div className="level mb-5 publication-analysis-comparison-toolbar">
              <div className="level-left">
                <h3 className="title is-4 has-text-white">{title} - Comparison</h3>
              </div>
              <div className="level-right">
                <div className="field" style={{ position: 'relative' }}>
                  <input
                    id={switchId}
                    type="checkbox"
                    name="layoutSwitch"
                    className="switch"
                    checked={!isRowLayout}
                    onChange={() => setIsRowLayout(!isRowLayout)}
                  />
                  <label htmlFor={switchId} className="has-text-white is-size-7">
                    Column View
                  </label>
                </div>
              </div>
            </div>
            <div className={`${isRowLayout ? 'columns' : 'columns is-multiline'} publication-analysis-comparison-grid`}>
              {comparisonFigures.map(figure => (
                <div key={figure.key} className={isRowLayout ? 'column' : 'column is-full mt-5'}>
                  <figure className="image comparison-modal-chart">
                    <img src={figure.src} alt={figure.alt} />
                  </figure>
                  <div className="has-text-centered mt-3">
                    <h4 className="subtitle is-6 has-text-white">
                      {figure.workshopName}{figuresByWorkshop.find(item => item.workshop.name === figure.workshopName)?.figures.length > 1 ? ` (${figure.landUse})` : ''}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
            <PublicationAnalysisMethodNote compact inverted />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareWorkshopsPublicationAnalysisRow;
